<template>
    <v-select v-bind="config"
              :options="optionList"
              v-model="selected"
              @search="search">
        <template #no-options="{ search, searching }">
            <template v-if="searching">Nincs találat</template>
            <template v-else>A kereséshez gépeljen</template>
        </template>
    </v-select>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select'

export default {
    name: "SelectComponent",
    components: {
        vSelect
    },
    props: {
        config: {
            type: Object,
            default: () => {}
        },
        externalOptions: {
            type: Array
        },
        searchOnServer:  {
            type: Boolean,
            default: false
        },
        apiCallback: {
            type: Function
        },
        minimumInputLength: {
            type: Number,
            default: 2
        },
        additionalApiCallbackParams: {
            type: Object,
            default: () => {}
        },
        value: {
            type: [String, Array, Object],
        }
    },
    data() {
        return {
            optionList: [],
            selected: null
        }
    },
    created() {
        this.optionList = this.externalOptions;
    },
    methods: {
        search(search, loading) {
            if (this.searchOnServer && search.length >= this.minimumInputLength) {
                loading(true);
                this.apiCallback({
                    params: {
                        ...this.additionalApiCallbackParams,
                        term: search,
                        type: 'query'
                    }
                }).then((response) => {
                    this.optionList = response.data;
                    loading(false);
                }).catch((err) => {
                    console.error(err);
                    loading(false);
                });
            }
        },
        setSelectedItem(item) {
            this.selected = item;
        }
    },
    watch: {
        value: {
            handler(newValue) {
                this.selected = newValue;
            },
            immediate: true
        },
        selected(newValue) {
            this.$emit('input', newValue);
        }
    }
}
</script>

<style scoped>

>>> {
    --vs-dropdown-option--active-bg: var(--default-color);
}

>>> .vs__selected-options {
    align-items: baseline!important;
}

>>> .vs__actions {
    align-self: flex-start;
    padding-top: 5px;
}

</style>
